export default __webpack_public_path__ + "static/media/member_card_v3_penuh.01ff2f3f.png";